module.exports = __webpack_public_path__ + "static/NeueMontreal-Medium-423d9540ce662350e523d64ce8dd8e7a.woff2";